module.exports = __webpack_public_path__ + "static/media/志雄科技LOGO_外部白框.01141634.png";